import { IMetaTemplate, MetaTemplatesService } from "@/services/templates-wpp-meta/meta-wpp-template.service";
import { ChatStore } from "@/stores/app/chatStore";
import { computed, ref, watch } from "vue";

export function FetchMetaTemplates(chatStore: ChatStore) {
    const metaWppTemplatesSvc = new MetaTemplatesService();
    const officialTemplates = ref<IMetaTemplate[]>([]);

    // `authUser._fetchInboxesFull` empurra os inboxes UM A UM (await por inbox),
    // então a lista cresce e esta busca é disparada várias vezes durante a carga.
    // Sem ordem garantida de resposta, uma busca antiga (com menos inboxes) pode
    // chegar depois e sobrescrever a nova. O contador descarta as atrasadas.
    let buscaAtual = 0;

    async function fetchMetaTemplates() {
        const minhaBusca = ++buscaAtual;
        const inboxes = chatStore.currentAccountInboxWithOfficialWppIntegration;

        // `allSettled` e não `all`: com `all`, um único inbox que falha (metade
        // oficial ainda não conectada, permissão, 404) rejeita o lote inteiro e
        // NENHUM template aparece — inclusive os dos inboxes que responderam.
        const resultados = await Promise.allSettled(inboxes.map(i => metaWppTemplatesSvc.findAllByInbox(i.id)));

        resultados.forEach((r, indice) => {
            if (r.status === 'rejected')
                console.warn(`[meta-templates] falha ao carregar os templates do inbox ${inboxes[indice]?.nome ?? inboxes[indice]?.id}:`, r.reason);
        });

        if (minhaBusca !== buscaAtual) return;

        officialTemplates.value = resultados
            .flatMap(r => (r.status === 'fulfilled' ? r.value : []));
    }

    /**
     * O gatilho é a LISTA de inboxes oficiais, não o booleano "tem algum".
     *
     * Com o booleano, a busca acontecia uma vez só: um segundo inbox oficial que
     * ficasse pronto depois (carga progressiva do authStore, conexão/conversão
     * de inbox) nunca era buscado, e trocar de conta não recarregava nada —
     * o booleano continuava `true`. O resultado era a tela mostrando os
     * templates de um inbox só, sem erro nenhum.
     */
    watch(
        () => chatStore.currentAccountInboxWithOfficialWppIntegration.map(i => i.id).sort().join(','),
        (chaveDosInboxes) => {
            if (!chaveDosInboxes) {
                officialTemplates.value = [];
                return;
            }
            void fetchMetaTemplates();
        },
        { immediate: true },
    );

    /**
     * Templates oficiais do inbox DONO do atendimento aberto.
     *
     * `officialTemplates` agrega todos os inboxes com metade Cloud API da conta
     * (é o que a tela de gestão precisa), mas um template mora no WABA de um
     * inbox só e não pode ser enviado por outro — no chat, oferecer os dos
     * vizinhos é oferecer um envio que a Meta recusa.
     */
    const officialTemplatesDoChatAtivo = computed<IMetaTemplate[]>(() => {
        const idInbox = chatStore.activeChat?.idInbox;
        if (!idInbox) return [];
        return officialTemplates.value.filter(t => String(t.idInbox) === String(idInbox));
    });

    return { officialTemplates, officialTemplatesDoChatAtivo, fetchMetaTemplates, metaWppTemplatesSvc }
}